import { openModal } from "../../../core/ModalStack";
import { CloneSelectionModalProps } from "./CloneSelectionModal";

export async function openCloneSelectionModal(props: CloneSelectionModalProps) {
  const { CloneSelectionModal } = await import("./CloneSelectionModal");
  //@ts-ignore
  openModal(CloneSelectionModal, props);
}
